module.exports = __webpack_public_path__ + "media/images/expert__sandra-betschart-65b5126375e597cf177f75b09ed2d61d.png";